import React from 'react'
import PropTypes from 'prop-types'

import LinkButton from '../LinkButton'

import './index.scss'
import pagenotfound from 'assets/images/pagenotfound.svg'

function PageNotFound({ canGoBack, text, goBackText }) {
  return (
    <div className='ublique-page-notfound'>
      <img alt='forbidden' src={pagenotfound} />
      <h1>{text}</h1>
      <LinkButton
        back
        canGoBack={canGoBack}
        className='ublique-page-notfound--back-button'
      >
        {goBackText}
      </LinkButton>
    </div>
  )
}

PageNotFound.propTypes = {
  text: PropTypes.string.isRequired,
  goBackText: PropTypes.string.isRequired
}

export default PageNotFound
